import { schema } from 'normalizr';

export const APPS_SCHEMA_KEY = 'apps';

export const appsSchema = new schema.Entity(
  APPS_SCHEMA_KEY,
  {},
  {
    idAttribute: value => value.app_id,
  }
);

export const appsListSchema = [appsSchema];
